// @flow

import { selectFromConfig } from '@gandi/redux-config';
import { useTranslator, localeSelector, mapTags } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { CommercialBlock } from 'src/Domain/CommercialBlock';
import { useAppSelector } from 'src/hooks/useAppSelector';
import { pathjoin } from 'src/modules/pathjoin';

const selectPublicUrl = selectFromConfig<string>(
  'app.layout.urls.public_site',
  'https://www.gandi.net',
);

export function TransferCommercialBlock(): React.MixedElement {
  const { __ } = useTranslator();

  const publicUrl = useAppSelector(selectPublicUrl);
  const locale = useAppSelector(localeSelector);
  const tldsUrl = pathjoin(publicUrl, locale, 'tlds');

  return (
    <CommercialBlock
      title={__(
        'Welcome to Gandi! To ensure a successful transfer, please review the following information:',
      )}
      link={
        <Button
          kind="link"
          href="https://docs.gandi.net/en/domain_names/transfer/tips.html"
        >
          {__('More infos')}
        </Button>
      }
      commercialPoints={[
        __('Your domain is not expiring in the next few days.'),
        mapTags(
          __(
            'Your domain has been registered or transferred with its current registrar for at least 60 days. ' +
              "(This is a general rule, but [[link:you can check the specific rules]] for your domain's extension.)",
          ),
          ({ link }) => ({ link: <a href={tldsUrl}>{link}</a> }),
        ),
        __('Transfer lock is disabled.'),
        __(
          'The email addresses of the owner and administrative contacts are up to date.',
        ),
      ]}
      commercialPointsIconName="checkmark"
    />
  );
}
